import { useNavigate } from 'react-router-dom'
import { Vars } from '@carrent/ui'

/**
 * Гаджет: сводка по регионам.
 *
 * Единственный табличный гаджет: сравнивать десяток регионов по четырём
 * величинам списком карточек невозможно — глаз должен идти по колонке.
 */
export function RegionsSummaryWidget({ data }) {
  const navigate = useNavigate()

  if (!data.rows.length) {
    return <p className="widget-empty">Регионы не заведены</p>
  }

  return (
    <div className="regions">
      <table className="regions__table">
        <caption className="visually-hidden">
          Парк, рейсы и ремонты по регионам за {data.period_days ?? '—'} дней
        </caption>
        <thead>
          <tr>
            <th scope="col">Регион</th>
            <th scope="col" className="regions__num">Машин</th>
            <th scope="col" className="regions__num">В рейсе</th>
            <th scope="col">Занятость</th>
            <th scope="col" className="regions__num">Ремонты</th>
          </tr>
        </thead>
        <tbody>
          {data.rows.map((r) => (
            <tr key={r.region_id}>
              <th scope="row">
                <button
                  type="button"
                  className="regions__link"
                  onClick={() => navigate(`/admin/regions/${r.region_id}`)}
                >
                  {r.name}
                </button>
              </th>
              <td className="regions__num">{r.cars}</td>
              <td className="regions__num">{r.active_trips}</td>
              <td>
                <span className="regions__track">
                  <Vars
                    as="span"
                    className="regions__bar"
                    vars={{ '--bar-w': `${r.load_pct ?? 0}%` }}
                  />
                </span>
                <span className="regions__pct">
                  {r.load_pct == null ? '—' : `${r.load_pct}%`}
                </span>
              </td>
              <td className="regions__num">
                {r.open_repairs > 0 ? (
                  <span className="regions__alert">{r.open_repairs}</span>
                ) : (
                  0
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {data.unassigned_cars > 0 && (
        <p className="widget-note">
          {data.unassigned_cars} машин без региона — в таблицу они не попадают.
        </p>
      )}
    </div>
  )
}
